import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=1d56193e&scoped=true"
var script = {}
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=1d56193e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d56193e",
  null
  
)

export default component.exports